import { gql } from "@apollo/client";

import { VAN_INTEGRATION_FIELDS } from "./fragments";

export const LIST_VAN_INTEGRATIONS = gql`
  ${VAN_INTEGRATION_FIELDS}
  query listVanIntegrations($includeDeleted: Boolean, $subaccountId: ID!) {
    listVanIntegrations(
      includeDeleted: $includeDeleted
      subaccountId: $subaccountId
    ) {
      ...VanIntegrationFields
    }
  }
`;

export const ADD_VAN_INTEGRATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  mutation addVanIntegration(
    $name: String!
    $applicationName: String!
    $password: String!
    $subaccountId: ID!
  ) {
    vanIntegrationCreate(
      name: $name
      applicationName: $applicationName
      password: $password
      subaccountId: $subaccountId
    ) {
      ...VanIntegrationFields
    }
  }
`;

export const EDIT_VAN_INTEGRATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  mutation editVanIntegration($id: ID!, $name: String, $password: String) {
    vanIntegrationUpdate(id: $id, name: $name, password: $password) {
      ...VanIntegrationFields
    }
  }
`;

export const DELETE_VAN_INTEGRATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  mutation deleteVanIntegration($id: ID!) {
    vanIntegrationDelete(id: $id) {
      ...VanIntegrationFields
    }
  }
`;

export const UNDELETE_VAN_INTEGRATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  mutation undeleteVanIntegration($id: ID!) {
    vanIntegrationUndelete(id: $id) {
      ...VanIntegrationFields
    }
  }
`;

export const CAMPAIGN_EDIT_VAN_INTEGRATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  mutation campaignEditVanIntegration(
    $id: ID!
    $integration: CampaignIntegrationInput
  ) {
    campaignEditVanIntegration(id: $id, integration: $integration) {
      id
      vanIntegration {
        vanIntegration {
          ...VanIntegrationFields
        }
        databaseMode
        canvassResultCodes {
          resultCodeId
          name
        }
      }
    }
  }
`;

export const GET_INTEGRATION_DETAILS_WITH_VALIDATION = gql`
  ${VAN_INTEGRATION_FIELDS}
  query vanIntegrationDetailsWithValidation($id: ID!) {
    vanIntegration(id: $id) {
      ...VanIntegrationFields
      introspectionData(withValidation: true) {
        id
        name
        createdAt
        updatedAt
        applicationName
        hasMyCampaign
        hasMyVoters
        databaseName
        committeeName
        keyReference
      }
    }
  }
`;
